import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { useAuth } from "../providers/AuthProvider";
import { useEmpresa } from "../providers/EmpresaProvider";

export default function ProtectedRoute({
  children,
  redirectTo = "/login",
  allowedRoles,
  requireLicense = false,
}) {
  const { isAuthenticated, loading, user } = useAuth();
  const { empresaId } = useEmpresa();
  const location = useLocation();

  if (loading) {
    return (
      <Box role="status" aria-label="Cargando sesión" sx={{ width: "100vw", height: "100dvh", display: "grid", placeItems: "center", bgcolor: "neutral.100" }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={redirectTo} replace state={{ from: location }} />;
  }

  const role = String(user?.user_role || "").toUpperCase();
  const normalizedAllowedRoles = Array.isArray(allowedRoles)
    ? allowedRoles.map((item) => String(item).toUpperCase())
    : [];

  if (normalizedAllowedRoles.length > 0 && !normalizedAllowedRoles.includes(role)) {
    return <Navigate to="/inicio" replace />;
  }

  if (requireLicense && role === "CONSULTORA" && !empresaId) {
    return <Navigate to="/consultora" replace />;
  }

  return children || <Outlet />;
}
